// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1d3MG","unreadBadge":"styles_unreadBadge__YyEmG","modalContent":"styles_modalContent__2IE9S","modal":"styles_modal__38lF1"};